(function () {
    'use strict';

    angular.module('ib-discounts-module')
        .service('DiscountsViewModel', DiscountsViewModel);

    DiscountsViewModel.$inject = ['NewMainHeaderConstants', '$filter', 'CommonsUtilService'];

    function DiscountsViewModel (NewMainHeaderConstants, $filter, CommonsUtilService) {
        const self = this;
        self.getDiscountModel = getDiscountModel;
        self.getDiscountsViewModel = getDiscountsViewModel;
        self.deleteDiscount = deleteDiscount;

        return self;

        function getDiscountsViewModel () {
            return {
                hasDiscounts: false,
                total: 0,
                discounts: {}
            };
        }

        function getDiscountModel (modelDiscount, type, totalPrice) {
            let discount = {};
            switch (type) {
                    case NewMainHeaderConstants.DISCOUNT_TYPES.AVIOS:
                        discount = createAviosDiscount(modelDiscount);
                        break;
                    case NewMainHeaderConstants.DISCOUNT_TYPES.VOUCHER:
                        discount = createVoucherDiscount(modelDiscount, totalPrice);
                        break;
                    case NewMainHeaderConstants.DISCOUNT_TYPES.DUMBO:
                        discount = createPartnerDiscount(modelDiscount, totalPrice);
                        break;
                    case NewMainHeaderConstants.DISCOUNT_TYPES.PLUTO:
                        discount = createPartnerDiscount(modelDiscount, totalPrice);
                        break;
                    case NewMainHeaderConstants.DISCOUNT_TYPES.PARTNER:
                        discount = createPartnerDiscount(modelDiscount, totalPrice);
                        break;
                    case NewMainHeaderConstants.DISCOUNT_TYPES.CORPORATE:
                        discount = createCorporateDiscount(modelDiscount, totalPrice);
                        break;
                    default:
                        discount = createVoucherDiscount(modelDiscount);
                        break;
            }
            return discount;
        }

        function createAviosDiscount (modelDiscount) {
            return {
                formattedElement: modelDiscount.formatedAvios,
                type: $filter('translate')(NewMainHeaderConstants.DISCOUNT_TYPES.AVIOS),
                discountFormatted: modelDiscount.discount,
                description:modelDiscount.description,
                discount: modelDiscount.originalDiscount
            };
        }

        function createVoucherDiscount (modelDiscount, totalPrice) {
            return {
                discountFormatted: modelDiscount.discount,
                discount: modelDiscount.originalDiscount || totalPrice,
                description:modelDiscount.description,
                type: $filter('translate')('BONUS_CARD_GIFT_TEXT')
            };
        }

        function createPartnerDiscount (modelDiscount, totalPrice) {
            return {
                discountFormatted: modelDiscount.discount,
                discount: modelDiscount.originalDiscount || totalPrice,
                description:modelDiscount.description,
                type: NewMainHeaderConstants.DISCOUNT_TYPES.PARTNER
            };
        }

        function createCorporateDiscount (modelDiscount, totalPrice) {
            return {
                discountFormatted: modelDiscount.discount,
                discount: modelDiscount.originalDiscount || totalPrice,
                description:modelDiscount.description,
                type: $filter('translate')(NewMainHeaderConstants.DISCOUNT_TYPES.CORPORATE)
            };
        }

        function deleteDiscount (modelDiscount, discountType) {
            let appliedDiscounts;
            if (discountType) {
                if (CommonsUtilService.isDiscountTypePartnerEquivalent(discountType)) {
                    discountType = NewMainHeaderConstants.DISCOUNT_TYPES.PARTNER;
                }
                if (modelDiscount.discounts[discountType]) {
                    modelDiscount.total -= modelDiscount.discounts[discountType].discount;
                }
                delete modelDiscount.discounts[discountType];
            } else {
                appliedDiscounts = Object.keys(modelDiscount.discounts);
                angular.forEach(appliedDiscounts, (discountKey) => {
                    delete modelDiscount.discounts[discountKey];
                });
                modelDiscount.hasDiscounts = false;
                modelDiscount.total = 0;
            }
        }
    }
}

)();